import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import {
  CapaQuotationUserBizType,
  useVerifyCompanyRegistrationNumberQuery
} from '@generated/graphql';
import useClient from '@hooks/useClient';
import { CompanyInfoEditProps, TypeSelectForm } from './types';
import { useForm } from 'react-hook-form';
import CompanyInfoEditPresenter from './CompanyInfoEditPresenter';

export default ({ open, onClose, onUpdate }: CompanyInfoEditProps) => {
  const initialTypeSelectForm: TypeSelectForm = {
    organizationName: '',
    companyRegistrationNumber: ''
  };

  const { onUpdateClient, clientState } = useClient();

  const useHookForm = useForm<TypeSelectForm>({
    mode: 'onChange',
    defaultValues: {
      organizationName: clientState.organizationName || '',
      companyRegistrationNumber: clientState.companyRegistrationNumber || ''
    }
  });

  const { trigger, setValue, getValues, register, reset } = useHookForm;

  const [isIndividual, setIsIndividual] = useState<boolean>(false);

  const { refetch } = useVerifyCompanyRegistrationNumberQuery({
    skip: true
  });

  const beforeSubmit = (data: TypeSelectForm) => {
    const updateForm = {
      ...initialTypeSelectForm,
      ...data,
      id: ''
    };
    if (isIndividual) {
      updateForm.organizationName = '';
    }
    if (!data.companyRegistrationNumber) {
      updateForm.companyRegistrationNumber = undefined;
    }
    return updateForm;
  };

  const onSubmit = (
    data: TypeSelectForm,
    e: BaseSyntheticEvent<object, any, any> | undefined
  ) => {
    e?.preventDefault();
    const updateForm = beforeSubmit(data);
    onUpdateClient({
      ...clientState,
      companyRegistrationNumber: data.companyRegistrationNumber
        ? data.companyRegistrationNumber
        : undefined
    });
    onUpdate({ ...updateForm, bizType: CapaQuotationUserBizType.Biz });
    onClose();
  };

  //   Effect
  useEffect(() => {
    trigger();
  }, [clientState.bizType, trigger]);

  useEffect(() => {
    if (getValues('companyRegistrationNumber')) {
      trigger('companyRegistrationNumber');
    }
    setIsIndividual(false);
  }, [trigger, getValues]);

  useEffect(() => {
    if (isIndividual) {
      setValue('organizationName', '');
    }
    trigger('organizationName');
  }, [isIndividual, getValues, setValue, trigger, register]);

  useEffect(() => {
    reset({
      organizationName: clientState.organizationName,
      companyRegistrationNumber: clientState.companyRegistrationNumber
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <CompanyInfoEditPresenter
      open={open}
      isIndividual={isIndividual}
      bizType={clientState.bizType}
      useHookForm={useHookForm}
      onClose={onClose}
      refetch={refetch}
      onSubmit={onSubmit}
    />
  );
};
